import React from 'react';
import './App.css';
import Header from './components/Header';
import BannerCarousel from './components/BannerCarousel';
import WelcomeSection from './components/WelcomeSection';
import WorkingProcess from './components/WorkingProcess';
import GallerySection from './components/GallerySection';
import DecorationSection from './components/DecorationSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <BannerCarousel />
      <WelcomeSection />
      <GallerySection />
      <DecorationSection />
      <WorkingProcess />
      <Footer />
    </div>
  );
}

export default App;
